import { SetStateAction, useEffect, useState } from "react";
import classNames from "classnames";
import dayjs, { Dayjs } from "dayjs";
import { useIntl } from "react-intl";
import { ChevronRight } from "@/public/icons/ChevronRight";
import { Invoice } from "@/interfaces/invoice";
import { Invoices } from "./invoices/Invoices";
import styles from "./Contract.module.scss";

export type NoContractProps = {
  invoices: Invoice[];
  startDate: Dayjs;
  endDate: Dayjs;
  itemsChecked: string[];
  setItemsChecked: React.Dispatch<SetStateAction<string[]>>;
};

export const NoContract = ({
  invoices,
  startDate,
  endDate,
  itemsChecked,
  setItemsChecked,
}: NoContractProps) => {
  const intl = useIntl();
  const [showDetails, setShowDetails] = useState<boolean>(false);
  const [invoicesCount, setInvoicesCount] = useState<number>(0);

  const getInvoicesCount = (): number => {
    const nb = invoices.filter(
      (invoice) =>
        dayjs(invoice.invoiceDate).isAfter(startDate) &&
        dayjs(invoice.invoiceDate).isBefore(endDate)
    ).length;

    setInvoicesCount(nb);

    return nb;
  };

  useEffect(() => {
    const nb = getInvoicesCount();

    if (nb > 0) {
      setShowDetails(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoices, startDate, endDate]);

  return (
    <>
      {invoicesCount > 0 && (
        <div className={styles.content}>
          <div className={styles.noContract}>
            <div className={styles.header}>
              <div className={classNames(styles.id, styles.caps)}>
                {intl.formatMessage({ id: "noContract" })}
              </div>
            </div>
            <div className={styles.infos}>
              <div
                className={classNames(styles.seeDetails, {
                  [styles.active]: showDetails,
                })}
                onClick={() => setShowDetails(!showDetails)}
              >
                <ChevronRight size={"24"} />
              </div>
            </div>
          </div>
          {showDetails && (
            <Invoices
              invoices={invoices}
              startDate={startDate}
              endDate={endDate}
              itemsChecked={itemsChecked}
              setItemsChecked={setItemsChecked}
            />
          )}
        </div>
      )}
    </>
  );
};
